export default {
  SET_REM_DIVISION_LIST(state, params) {
    state.remDivisionList = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/division/divisionMutations.js